<template>
  <div>
    <el-card shadow="never">
          <div slot="header">
            <span class="title">基本信息</span>
        <el-button type="primary" v-show="disabled" plain class="title-btn" @click="back()">返回</el-button>
      </div>
      <div style="width: 600px;">
        <el-form ref="infoForm" :model="ruleForm" :rules="formRules" label-width="100px">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="ruleForm.taskName" :disabled="disabled" placeholder="请输入任务名称" />
          </el-form-item>
          <template v-for="(row,index) in ruleForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" prop="coupon">
              <div class="d-flex">
                <el-select v-model="row.couponId" filterable style="width: 200px;" :disabled="disabled" placeholder="请选择优惠券">
                  <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                </el-select>
                <el-input v-model="row.count" class="ml-20" style="width: 100px;" :disabled="disabled" placeholder="请输入数量" />
                <div class="ml-20">张</div>
                <i v-show="!disabled" class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(index)" />
                <i v-show="index!==0 && !disabled" class="icon-jia ml-20 el-icon-remove-outline" @click="delCoupon(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
          <el-form-item label="发放目标" prop="releaseTarget">
            <el-radio-group v-model="ruleForm.releaseTarget" :disabled="disabled">
              <el-radio v-for="(item, index) in targetArray" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
            <!-- 选择用户 -->
            <div v-show="ruleForm.releaseTarget===3" class="border">
              <el-input v-show="!disabled" v-model="filterUserText" placeholder="输入关键字进行过滤" />
              <!-- <el-tree
                ref="treeUser"
                :data="userTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="ruleForm.user"
                :filter-node-method="filterUserNode"
                @check-change="handleUserChange"
              /> -->
                 <GoodStree  @check="checkFn1"  :tempText="filterUserText"  v-model="ruleForm.user" :data="userTreeData" :is-show-filter="false"/>
            </div>
            <!-- 选择企业 -->
            <div v-show="ruleForm.releaseTarget===2" class="border">
                        <!-- <el-input
      placeholder="输入关键字进行过滤"
      v-model="tempText2"
    /> -->
              <el-input v-show="!disabled" v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <!-- <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="ruleForm.mechanism"
                :filter-node-method="filterMechanismNode"
                @check-change="handleMechanismChange"
              /> -->
                <GoodStree @check="checkFn2" v-model="ruleForm.mechanism" :tempText="filterMechanismText" :data="mechanismTreeData" :is-show-filter="false"/>
            </div>
            <!-- 选择标签 -->
            <div v-show="ruleForm.releaseTarget===1" class="border">
              <el-input v-show="!disabled" v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <!-- <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="ruleForm.tag"
                :filter-node-method="filterTagNode"
                @check-change="handleTagChange"
              /> -->
                  <GoodStree @check="checkFn3" v-model="ruleForm.tag" :tempText="filterTagText" :data="tagTreeData" :is-show-filter="false"/>

            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
            <div slot="header">
          <span style="font-weight:600;color:#000">发放模式</span>
        </div>
        <div style="width: 600px;">
          <el-form ref="patternForm" :model="patternForm" :rules="patternRules" label-width="100px">
            <el-form-item label="选择模式" prop="grantModel">
              <el-radio-group v-model="patternForm['grantModel']" :disabled="disabled">
                <el-radio
                  v-for="(item, index) in constant.task.grantModel"
                  :key="index"
                  :label="item.value"
                  @change="cleanGrantModelJsonDate"
                >{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 周期发放 -->
            <template v-if="patternForm['grantModel'] == 2">
              <el-form-item label="总发放次数" prop="cycleCount">
                <el-input v-model="patternForm['cycleCount']" placeholder="请输入总发放次数" :disabled="disabled" />
              </el-form-item>
              <el-form-item>
                <el-radio-group v-model="patternForm.grantModelJsonType" :disabled="disabled">
                  <el-radio
                    v-for="(item, index) in constant.task.grantModelCycle"
                    :key="index"
                    :label="item.value"
                    @change="cleanGrantModelJsonDate"
                  >{{ item.label }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 周期发放---每日发放 -->
              <template v-if="patternForm.grantModelJsonType == 'day'">
                <el-form-item prop="grantModelJsonDate">
                  <el-time-picker v-model="patternForm.grantModelJsonDate" value-format="yyyy-MM-dd HH:mm" placeholder="选择时间" :disabled="disabled" />
                </el-form-item>
              </template>
              <!-- 周期发放---每周发放 -->
              <template v-else-if="patternForm.grantModelJsonType == 'week'">
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="grantModelJsonWeek">
                      <el-select v-model="patternForm.grantModelJsonWeek" placeholder="请选择星期" :disabled="disabled">
                        <el-option v-for="item in constant.task.week" :key="item.value" :label="item.label" :value="item.value" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="grantModelJsonDate" label-width="10px">
                      <el-time-picker v-model="patternForm.grantModelJsonDate" value-format="yyyy-MM-dd HH:mm" placeholder="选择时间" :disabled="disabled" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
              <!-- 周期发放---每月发放 -->
              <template v-else-if="patternForm.grantModelJsonType == 'month'">
                <el-row>
                  <el-col :span="10">
                    <el-form-item prop="monthDay">
                      <el-select v-model="patternForm.monthDay" placeholder="请选择天" :disabled="disabled">
                        <el-option v-for="item in 31" :key="item" :label="item" :value="item" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="grantModelJsonDate" label-width="10px">
                      <el-time-picker
                        v-model="patternForm.grantModelJsonDate"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="选择时间"
                        :disabled="disabled"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </template>
            </template>

            <!-- 定时发放 -->
            <template v-else-if="patternForm['grantModel'] == 3">
              <el-form-item label="发放时间" prop="grantModelJsonDate">
                <el-date-picker
                  v-model="patternForm.grantModelJsonDate"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择时间"
                  :disabled="disabled"
                />
              </el-form-item>
            </template>
          </el-form>
        </div>
            </el-card>
    <div v-show="!disabled" class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
    <el-card shadow="never" v-show="disabled">
          <div slot="header">
            <span class="title">发放记录</span>
      </div>
      <STable
        v-if="url"
        ref="tableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        label-width="100px"
        :toolbar="toolbar"
      />
    </el-card>
  </div>
</template>

<script>
import Constant from '@/utils/crmConstant.json'
import {
  HOST
} from '@/utils/host'
import { numberfilter } from '@/utils/tool'
import {
  treeDisabled
} from '@/utils/tool'
import Moment from 'moment'
export default {
  // props: {
  //   title: {
  //     type: String,
  //     default() {
  //       return '详情'
  //     }
  //   },
  //   dataObj: {
  //     type: Object,
  //     default() {
  //       return {}
  //     }
  //   },
  //   disabled: {
  //     type: Boolean,
  //     default() {
  //       return false
  //     }
  //   }
  // },
  data() {
    return {
        checkarr:[],
        checkarr2:[],
        checkarr3:[],
      constant: Constant,
      tempText2:'',
      dataId: '',
      // 所有的优惠券数据
      allCoupon: [],
      // 发放目标
      targetArray: [{
        label: '标签',
        id: 1
      }, {
        label: '企业',
        id: 2
      }, {
        label: '用户',
        id: 3
      }],
      // 发放模式
      modeArray: [{
        label: '立即发放',
        id: 1
      }, {
        label: '定时发放',
        id: 2
      }, {
        label: '周期发放',
        id: 3
      }],
      ruleForm: {},
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterUserText: '', // 用户过滤
      filterMechanismText: '', // 企业过滤
      filterTagText: '', // 标签过滤
      userTreeData: [], // 用户树的全部数据
      mechanismTreeData: [], // 企业树的全部数据
      tagTreeData: [], // 标签树的全部数据
      formRules: {
        taskName: [{
          required: true,
          message: '请输入优惠名称',
          trigger: 'blur'
        }],
        coupon: { required: true, trigger: ['change', 'blur'], validator: (rewardRules, value, cb) => {
          if (this.couponRule) {
            return cb(new Error(this.couponRule))
          }
          return cb()
        } },
        releaseTarget: [{
          required: true,
          message: '请选择发放目标',
          trigger: 'change'
        }]
      },
      patternForm: {
        grantModel: 1, // 选择模式
        grantModelJsonType: 'day',
        // 每日每周每月的时间选择字段 共用的
        grantModelJsonDate: Moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
        grantModelJsonWeek: '',
        monthDay: '', // 月份天数1-31
        cycleCount: ''// 总发放次数
      },
      patternRules: {
        grantModel: [
          { required: true, message: '请选择模式', trigger: 'change' }
        ],
        cycleCount: [
          { required: true, message: '请输入总发放次数', trigger: 'blur' }
        ],
        grantModelJsonDate: [
          { type: 'string', required: true, message: '请选择时间', trigger: 'change' }
        ]
      },
      url: '',
      columns: [{
        label: '所属企业',
        prop: 'orgName'
      }, {
        label: '用户账号',
        prop: 'userAccount'
      }, {
        label: '用户姓名',
        prop: 'userName'
      }, {
        label: '手机号',
        prop: 'userPhone'
      }, {
        label: '优惠券名称',
        prop: 'couponName'
      }, {
        label: '优惠券编号',
        prop: 'couponCode'
      }, {
        label: '发放时间',
        prop: 'createTime'
      }],
      query: [{
        label: '所属企业',
        prop: 'orgName',
        placeholder: '请输入企业名称'
      }, {
        label: '用户账号',
        prop: 'userAccount',
        placeholder: '请输入用户账号'
      }, {
        label: '手机号',
        prop: 'userPhone',
        placeholder: '请输入手机号'
      }, {
        label: '发放时间',
        prop: 'createTime',
        placeholder: '',
        type: 'date2'
      }, {
        label: '优惠券名称',
        prop: 'couponName',
        placeholder: '请输入优惠券名称'
      }, {
        label: '优惠券编号',
        prop: 'couponCode',
        placeholder: '请输入优惠券编号'
      }],
      toolbar: [{
        label: '导出',
		icon: 'el-icon-download',
        type: 'primary',
        handle: (index, record) => {
          const url = HOST + '/admin/coupon/exportUserCouponList?type=1&taskId=' + this.dataId
          const data = this.$refs.tableref.getQueryData()
          $.fileDownload(url, {
            httpMethod: 'GET',
            data: {
              token: window.localStorage.getItem('token'),
              ...data
            },
            failCallback: (html, url) => {
              this.$notify({
                title: '失败',
                message: '导出发放记录失败',
                type: 'error'
              })
            }
          })
        }
      }]
    }
  },
  computed: {
    // 优惠券的动态校验
    couponRule() {
      const dataArray = this.ruleForm.coupon
      for (let i = 0; i < dataArray.length; i++) {
        const currentObj = dataArray[i]
        if (currentObj.couponId === '' && !currentObj.couponId.length) {
          return '请选择优惠券'
        }
        if (!currentObj.count && !currentObj.count.length) {
          return '请输入数量'
        }
        if (this.queryCouponStock(currentObj.couponId) && currentObj.count > this.queryCouponStock(currentObj.couponId)) {
          return '优惠券数量大于库存数量'
        }
      }
      return ''
    }
  },
  watch: {
    filterUserText(val) {
      this.$refs.treeUser.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  beforeMount() {
          this.title=this.$route.query.title
      this.disabled=eval(this.$route.query.disabled)
     this.dataObj=JSON.parse(decodeURIComponent(this.$route.query.dataObj))
    this.dataId = this.dataObj.id
    this.url = '/admin/coupon/getUserCouponList?taskId=' + this.dataId
  },
  mounted() {
    this.ruleForm = {
      taskName: this.dataObj.taskName,
      coupon: JSON.parse(this.dataObj.couponData),
      releaseTarget: this.dataObj.sendType,
      user: this.dataObj.sendType === 3 ? this.dataObj.sendData.split(',') : [], // 选择用户
      mechanism: this.dataObj.sendType === 2 ? this.dataObj.sendData.split(',') : [], // 选择企业
      tag: this.dataObj.sendType === 1 ? this.dataObj.sendData.split(',') : [] // 选择标签
    }
    
    this.patternForm.grantModel = this.dataObj.type // 选择模式
    const taskTime = JSON.parse(this.dataObj.taskData)
    if (this.dataObj.type === 2) {
      this.patternForm.grantModelJsonType = taskTime.timeType
      this.patternForm.cycleCount = taskTime.limitCount
      if (taskTime.timeType === 'week') {
        this.patternForm.grantModelJsonWeek = taskTime.date.day
      } else if (taskTime.timeType === 'month') {
        this.patternForm.monthDay = taskTime.date.day
      }
      this.patternForm.grantModelJsonDate = taskTime.date.time
    } else if (this.dataObj.type === 3) {
      this.patternForm.grantModelJsonDate = taskTime.time
    }
    this.$nextTick(() => {
      // 加载树数据
      this.getUser()
      this.getMechanismTree()
      this.getTagTree()
      this.loadCoupon()
    })
        this.checkarr=this.ruleForm.user
    console.log(this.checkarr,'arrrrrr')
    this.checkarr2=this.ruleForm.mechanism
      this.checkarr3=this.ruleForm.tag
  },
  methods: {
    checkFn1(e){
            //   this.ruleForm.user=e
            this.checkarr=e
    },
    checkFn2(e){
        this.checkarr2=e
//   this.ruleForm.mechanism=e
    },
    checkFn3(e){
            this.checkarr3=e
// this.ruleForm.tag=e
    },
    numberfilter(num) {
      return numberfilter(num)
    },
    cleanGrantModelJsonDate() {
      this.patternForm.grantModelJsonDate = Moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
    },
    // 查询全部用户树的数据
    getUser() {
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getOrgAndUser',
        method: 'get',
        callback: resp => {
          if (this.disabled) {
            this.userTreeData = treeDisabled(resp, true)
          } else {
            this.userTreeData = resp
          }
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
		data: { orgType: '1,3' },
        callback: resp => {
          if (this.disabled) {
            this.mechanismTreeData = treeDisabled(resp, true)
          } else {
            this.mechanismTreeData = resp
          }
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
		data: { orgType: '1,3', labelType:'0' },
        callback: resp => {
          if (this.disabled) {
            this.tagTreeData = treeDisabled(resp, true)
          } else {
            this.tagTreeData = resp
          }
        }
      })
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          this.allCoupon = resp.list
        }
      })
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    // 表单添加一行优惠券
    addCoupon(index) {
      const data = {
        couponId: '', // 优惠券id
        count: '' // 优惠券数量
      }
      this.ruleForm.coupon.splice(index + 1, 0, data)
    },
    // 删除删除一行优惠券
    delCoupon(index) {
      this.ruleForm.coupon.splice(index, 1)
    },
    onSubmit() {
        
      let ruleFormBool = false
      this.$refs['infoForm'].validate(valid => {
        ruleFormBool = valid
      })
      console.log(ruleFormBool)
      let configFormBool = false
      this.$refs['patternForm'].validate(valid => {
        configFormBool = valid
      })
      if (ruleFormBool && configFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    // 优惠券选中的change方法
    selectData(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.couponName || ''
    },
    submitData() {
      // 获取所有的优惠券数据
      const couponData = this.ruleForm.coupon.map(item => {
        return {
          couponId: item.couponId,
          couponName: this.selectData(item.couponId),
          count: item.count
        }
      })
      // 周期发放里面的三个单选枚举 day week month，因为这里也是选择，所以也是枚举
      const issuanceOptions = {
        // 每日发放
        'day': () => {
          return {
            time: this.patternForm.grantModelJsonDate
          }
        },
        // 每周发放
        'week': () => {
          return {
            day: this.patternForm.grantModelJsonWeek,
            time: this.patternForm.grantModelJsonDate
          }
        },
        // 每月发放
        'month': () => {
          return {
            day: this.patternForm.monthDay,
            time: this.patternForm.grantModelJsonDate
          }
        }
      }
      // 选择模式的枚举
      const selectOptions = {
        // 立即发放
        1: () => {
          const data = {
            time: Moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
          }
          return JSON.stringify(data)
        },
        // 周期发放
        2: () => {
          // 总发放次数
          const cycleCount = this.patternForm.cycleCount
          // 每日 每周 每月发放的选择字段
          const grantModelJsonType = this.patternForm.grantModelJsonType
          // 每日 每周 每月发放下面的时间，每周和每月是两个字段，所以又做了个枚举
          const date = issuanceOptions[grantModelJsonType]()
          const data = {
            limitCount: cycleCount, // 总发放次数
            timeType: grantModelJsonType, // 每日 每周 每月发放的选择字段
            date: date
          }
          return JSON.stringify(data)
        },
        // 定时发放
        3: () => {
          const data = {
            time: this.patternForm.grantModelJsonDate
          }
          return JSON.stringify(data)
        }
      }
      // 选择发放目标后下面的树的枚举
      const targetOptions = {
        // 标签
        1: () => {
          // 获取所有的id 字符串 以逗号分割
        //   const id = this.ruleForm.tag.join(',')
          const id = this.checkarr3.join(',')
          return id
        },
        // 企业
        2: () => {
          // 获取所有的id 字符串 以逗号分割
        //   const id = this.ruleForm.mechanism.join(',')
           const id = this.checkarr2.join(',')
          return id
        },
        // 用户
        3: () => {
          // 获取所有的id 字符串 以逗号分割
        //   const id = this.ruleForm.user.join(',')
          const id = this.checkarr.join(',')
          return id
        }
      }
      console.log(this.ruleForm.releaseTarget,'iddddddddddd')
      const data = {
        id: this.dataObj.id,
        taskName: this.ruleForm.taskName, // 任务名称
        couponData: JSON.stringify(couponData), // 动态添加的优惠券数据
        sendType: this.ruleForm.releaseTarget, // 发放目标
        sendData: targetOptions[this.ruleForm.releaseTarget](), // 发放目标下面的树，字符串 以逗号隔开
        type: this.patternForm.grantModel, // 选择模式
        taskData: selectOptions[this.patternForm.grantModel]()// 选择完模式后下面的字段
      }
      console.log('最终的数据：', data)
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/addTask',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 1500
          })
        //   this.$router.go(0)
        }
      })
    },
    filterTagNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleTagChange(data, checked, indeterminate) {
      this.ruleForm.tag = this.$refs.treeTag.getCheckedKeys()
    },
    filterMechanismNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.ruleForm.mechanism = this.$refs.treeMechanism.getCheckedKeys()
    },
    filterUserNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleUserChange(data, checked, indeterminate) {
    //   this.ruleForm.user = this.$refs.treeAccount.getCheckedKeys()
    },
    cancel() {
      this.$router.go(-1)
    },
    back() {
      // this.$emit('backHome')
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter {
    display: flex;
    justify-content: center;
  }

  .mt-25 {
    margin-top: 25px;
  }

  .ml-20{
    margin-left: 20px;
  }

  .d-flex{
    display: flex;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .border{
    border: 1px solid #EEEEEE;
    padding: 20px;
    height: 300px;
    // overflow-y: auto;
  }
</style>



// WEBPACK FOOTER //
// src/views/discount/manualReleaseUpdate.vue